import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import {
  LucideAngularModule,
  ReceiptText,
  Users,
  Calculator,
  QrCode,
  ScanLine,
  MousePointerClick,
  ArrowRight,
  ChevronDown,
} from 'lucide-angular';

@Component({
  selector: 'app-public-bill-split-entry',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './public-bill-split-entry.html',
})
export class PublicBillSplitEntryComponent {
  private router = inject(Router);

  readonly howItWorksOpen = signal(false);

  readonly ChevronDown = ChevronDown;
  readonly ReceiptText = ReceiptText;
  readonly Users = Users;
  readonly Calculator = Calculator;
  readonly QrCode = QrCode;
  readonly ScanLine = ScanLine;
  readonly MousePointerClick = MousePointerClick;
  readonly ArrowRight = ArrowRight;

  goToDivider(): void {
    this.router.navigate(['/divisor-cuenta'], {
      queryParams: { entry: 'landing' },
    });
  }
}
